export default __webpack_public_path__ + "static/media/download-arrow.aefda3b6.svg";